export default "__VITE_ASSET__6e326d59__"